import gql from 'graphql-tag'

export const ALL_CUSTOMER_CONTRACT_INVOICES_V2 = gql`
  query AllCustomerContractInvoices($brandUuid: ID) {
    allCustomerContractInvoices(brandUuid: $brandUuid) {
      invoices {
        customerContract {
          signedAt
          invoices {
            uuid
            description
            dueDate
            customerContract {
              uuid
              projects {
                name
              }
            }
            amountPaid {
              amount
              currency {
                symbol
                code
              }
            }
            total {
              amount
              currency {
                symbol
                code
              }
            }
            tax {
              amount
              currency {
                symbol
                code
              }
            }
            price {
              amount
              currency {
                symbol
                code
              }
            }
          }
        }
      }
    }
  }
`



// WEBPACK FOOTER //
// ./src/queries/AllCostumerContractInvoicesv2.tsx